import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from "rxjs";
import { SubHeader } from '../../../core/models/sub-header.model';
import { SubHeaderService } from '../../../core/services/sub-header.service';
import { Organization } from '../../models/organization.model';
import { AuthService } from "../../../services/auth.service";
import { OrganizationService } from "../../services/organization.service";
import { LoaderService } from "../../services/loader.service";

@Component({
    selector: 'org-file-page',
    templateUrl: './org-file-page.component.html',
    styleUrls: ['./org-file-page.component.scss'],
    standalone: false
})
export class OrgFilePageComponent implements OnInit, OnDestroy {

    organization: Organization;

    subHeader = new SubHeader({
    title: "Organization Files", buttons: []
    });

    subscription: Subscription = new Subscription();

    constructor(public auth: AuthService, private _organizationService: OrganizationService, public subHeaderService: SubHeaderService, public loader: LoaderService) { }

    ngOnInit() {
        this.subHeaderService.updateSubHeader(this.subHeader);
        this.loader.toggleLoader(true);
        const orgId = this.auth.User.organizationId;
        const subs$ = this._organizationService.getOrganization(orgId).subscribe(
            (orgData: Organization) => {
                this.organization = orgData;
                this.loader.toggleLoader(false);
            },
            (error) => {
                this.handleError(error);
            }
        );
        this.subscription.add(subs$);
    }

    ngOnDestroy() {
        if (this.subscription) this.subscription.unsubscribe();
    }

    handleError(error: any): void {
        console.error(error);
        this.loader.toggleLoader(false);
    }
}
